module.exports = __webpack_public_path__ + "static/WhyImportant-63ce843bb2532395d0aa0a5a20ff77ba.jpg";